import { render, staticRenderFns } from "./ContainerObservacaoVazio.vue?vue&type=template&id=eceecf98&scoped=true"
var script = {}
import style0 from "./ContainerObservacaoVazio.vue?vue&type=style&index=0&id=eceecf98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eceecf98",
  null
  
)

export default component.exports